// extracted by mini-css-extract-plugin
module.exports = {"superbar":"styles_superbar__EncXb","wrapper":"styles_wrapper__uuVhE","link":"styles_link__IjOgD","logo":"styles_logo__aAK3c"};